/**
 * 参数接口
 */

import instance from '@/utils/axios';

/**
 *  获取参数
 * @param {设备号} sn
 * @param {查询类型} busiType 2：查询默认参数 其他值：查询现在参数
 */
export function queryParams(sn, busiType) {
  return instance.get('/param/queryParam', {
    params: {
      sn,
      busiType
    }
  });
}

/**
 * 更新参数
 * @param {参数数据} data
 */
export function updateParams(data) {
  return instance.post('/param/updateParam', {
    ...data
  });
}
